import entity from '../../../models/cms/banners'

export default [
  {
    path: '/banners',
    meta: {
      entity,
      requiresPermissionTo: 'banners',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/banners/new',
    meta: {
      entity,
      requiresPermissionTo: 'banners',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/banners/:id',
    meta: {
      entity,
      requiresPermissionTo: 'banners',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
